/**
 * @fileoverview Sales roster, targets and dashboard query keys.
 * @description Live in shared so the feature that owns these queries (features/sales) and the one
 * that has to refresh them when a user is deactivated or reactivated (features/users, whose
 * lifecycle commands move reports and transfer targets) can name them without one feature
 * importing the other (ADR-0002).
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

/** Shared prefix for every sales-roster query key (the list and the per-user profile both start
 * with this), so one invalidateQueries({ queryKey: SALES_ROSTER_QUERY_KEY }) call after a create,
 * update, deactivate or reactivate refreshes every view at once, owner pickers included. */
export const SALES_ROSTER_QUERY_KEY = ['sales', 'sales-users']

/** Shared prefix for every target-related query key (list variants and the 'byTenant' sub-key both
 * start with this), so one invalidateQueries({ queryKey: TARGETS_QUERY_KEY }) call after a mutation
 * refreshes every form at once. */
export const TARGETS_QUERY_KEY = ['sales', 'targets']

/** The Sales Dashboard's query key. Its Sales Team and User Management figures move with a user's
 * lifecycle, so features/users marks it stale after one. */
export const SALES_DASHBOARD_QUERY_KEY = ['sales', 'crm', 'sales-dashboard'] as const
